import { Link } from "react-router-dom";

const UserLink = (props) => {
  const path = { pathname: `${props.linkTo}` };
  return (
    <Link className={props.cName} to={path} onClick={props.onClick}>
      {props.children}
    </Link>
  );
};

export default UserLink;

//cannot use with Heroku- Linkn from react router works only, page breats with CANNOT GET / when using href
